/* global _ */

import api from './api';

const { noop } = _;

export default function( request, callback ) {
	callback = callback || noop;

	var endpoint = 'innoway/stops';
	if ( typeof request.text !== 'undefined' ) {
		endpoint = 'innoway/v2/free_text';
	}

	api( endpoint, request, response => {
		callback( response );
	}, 'POST' );
}
